export const COMPLETED_CLASS_NAME = 'is-completed'
export const NOT_COMPLETED_CLASS_NAME = 'not-completed'
export const HS_TRAINING_URL = 'product/high-school/training'
